import {
  Group,
  GroupItem,
  WorkflowContext,
  useFieldLabel,
} from "ra-friendsofbabba";
import React, { useContext, useMemo } from "react";
import {
  SelectInput,
  useMutation,
  useNotify,
  useRefresh,
  useTranslate,
} from "react-admin";

import ConfirmButton from "../buttons/ConfirmButton";
import { useFormState } from "react-final-form";

const TransictoryStateInput = ({ source, record, resource }) => {
  const { getWorkflow } = useContext(WorkflowContext);
  const refresh = useRefresh();
  const translate = useTranslate();
  const notify = useNotify();
  const { values } = useFormState({ subscription: { values: true } });
  const fieldLabel = useFieldLabel({ resource: resource });
  const { states, disabled } = useMemo(() => {
    const filter = record?.transaction?.state;
    const workflow = getWorkflow(resource);
    const states = workflow?.states.filter((s) => s.code !== filter);
    const disabled = values?.transictory_state ? false : true;
    return { states, disabled };
  }, [getWorkflow, resource, values, record]);
  console.log(values);
  const [confirm, { loading }] = useMutation(
    {
      type: "post",
      resource: "projects/change-state",
      payload: {
        id: record?.id,
        transictory_state: values?.transictory_state,
      },
    },
    {
      onSuccess: () => {
        refresh();
        notify("resources.projects.notification.changed_state", "info");
      },
    }
  );

  return (
    <Group wrapper fullWidth>
      <GroupItem lg={4} md={5} sm={6}>
        <SelectInput
          label={fieldLabel("transictory_state")}
          source={source}
          choices={states}
          optionText="name"
          optionValue="code"
          allowEmpty
          helperText={translate(fieldLabel("transictory_state.help"))}
        />
      </GroupItem>
      <GroupItem lg={2} md={2} sm={3} xs={6}>
        <ConfirmButton onClick={confirm} disabled={disabled || loading} />
      </GroupItem>
    </Group>
  );
};
export default TransictoryStateInput;
